import { CerNavigationNode, CerNavigationSetting, CerRouteSetting } from "@app/app.module-generated";

export class CerAppNavigationNodesLoader {
  private nodes: CerNavigationNode[] = [];

  constructor(private routeSettings: CerRouteSetting[], private navigationSettings: CerNavigationSetting[]) { }

  public load(): CerNavigationNode[] {
    this.routeSettings?.forEach(r => {
      if (r.navHide !== true) {
        this.loadRoute(r);
      }
    });
    this.nodes.filter(node => node.position == 'last').forEach(node => this.moveLast(node));
    return this.nodes;
  }

  private moveLast(node: CerNavigationNode) {
    const idx = this.nodes.indexOf(node);
    if (idx < this.nodes.length - 1) {
      this.nodes.splice(idx, 1);
      this.nodes.push(node);
    }
  }

  public loadRoute(route: CerRouteSetting) {
    const pathUrl = route?.navPath ??
     ((route.navPrefix?.length > 0) 
      ? route.navPrefix + '/' + route.path 
      : route.path);
    var paths: string[] = pathUrl.split("/");
    if (route.navAdmin) {
      paths.splice(0, 0, 'admin');
    }

    var nodeId: string = '';

    var lvl = 0;
    var nodes = this.nodes;
    paths.forEach(p => {
      if (nodes != null) {
        lvl++;
        nodeId = (nodeId.length > 0 ? nodeId + '/' : '') + p;
        var node: CerNavigationNode = nodes.find(n => (<any>n).nodeId == nodeId);
        if (node == null) {
          if (paths.length > lvl) {
            const parent = this.navigationSettings.find(ns => ns.path == nodeId);
            if (parent != null) {
              node = { nodeId: nodeId, nodeText: parent.title, navShortcut: parent.navShortcut, roles: parent.roles, childNodes: [], position: parent.position };
            }
          }
          else {
            node = { nodeId: nodeId, url: route.path, nodeText: route.navTitle ?? route.title, navShortcut: route.navShortcut, roles: route.roles, childNodes: [] };
          }
          if (node != null) {
            nodes.push(node);
          }
        }
        nodes = node?.childNodes;
      }
    });
  }
}
